// assets

import { ProfileOutlined, FileTextOutlined } from "@ant-design/icons";
import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import DescriptionIcon from "@mui/icons-material/Description";
import SearchIcon from "@mui/icons-material/Search";
import { FormattedMessage, useIntl } from "react-intl";
// icons

const usePackagesItem = () => {
  const icons = {
    BusinessCenterOutlinedIcon,
    ProfileOutlined,
    FileTextOutlined,
    CheckCircleOutlineIcon,
    DescriptionIcon,
    SearchIcon,
  };

  // ==============================|| MENU ITEMS - EXTRA PAGES ||============================== //

  const packages = {
    id: "backages-and-subscription-management",
    title: (
      <FormattedMessage id="Orders and Subscriptions">
        {(text) => (
          <span style={{ fontSize: "14px", fontWeight: "normal" }}>{text}</span>
        )}
      </FormattedMessage>
    ),
    icon: icons.BusinessCenterOutlinedIcon,
    // url: "/vacancies-packages",
    type: "group",
    children: [
      /*
      {
        id: "search-engine-credits",
        title: <FormattedMessage id="search-engine-credits" />,
        type: "item",
        url: "/search-engine-credits",
        icon: icons.SearchIcon,
        breadcrumbs: false,
      },
      */
      {
        id: "vacancies-packages",
        title: <FormattedMessage id="Vacancies Packages" />,
        type: "item",
        url: "/vacancies-packages",
        icon: icons.BusinessCenterOutlinedIcon,
        breadcrumbs: false,
      },
      {
        id: "resumes-packages",
        title: <FormattedMessage id="Resumes Packages" />,
        type: "item",
        url: "/resumes-packages",
        icon: icons.ProfileOutlined,
        breadcrumbs: false,
      },
      {
        id: "orders",
        title: <FormattedMessage id="Orders" />,
        type: "item",
        url: "/orders",
        icon: icons.CheckCircleOutlineIcon,
        breadcrumbs: false,
      },

      {
        id: "vacancy-subscriptions",
        title: <FormattedMessage id="Vacancies Subscriptions" />,
        type: "item",
        url: "/vacancy-subscriptions",
        icon: icons.DescriptionIcon,
        breadcrumbs: false,
      },
      {
        id: "resume-subscriptions",
        title: <FormattedMessage id="Resumes Subscriptions" />,
        type: "item",
        url: "/resume-subscriptions",
        icon: icons.DescriptionIcon,
        breadcrumbs: false,
      },
      {
        id: "purchased_resumes",
        title: <FormattedMessage id="Purshased Resumes" />,
        type: "item",
        url: "/purchased-resumes",
        icon: icons.DescriptionIcon,
        breadcrumbs: false,
      },
    ],
  };
  return packages;
};

export default usePackagesItem;
